import React, { useEffect, useCallback } from 'react';
import { Route } from 'react-router-dom';
import {
  pathname,
  addOnboardingStepNumbers,
  addOnboardingStepNumbers8Data,
  is8DataApp,
} from '../../utils';
import { useOnboardingContext } from '../../contexts';
import { onboardingPages } from './onboarding-pages';

export default function OnboardingRoutes() {
  const { setFinishedSettingPageNumbers } = useOnboardingContext();

  const is8Data = is8DataApp();

  const setOnboardingPageNumbers = useCallback(() => {
    const hasStepNumbers =
      pathname.onboarding.main.createFirstLine.stepInStepper;
    if (!hasStepNumbers) {
      if (is8Data) {
        addOnboardingStepNumbers8Data(pathname.onboarding);
      } else {
        addOnboardingStepNumbers({
          onboardingPages: pathname.onboarding,
        });
      }
      setFinishedSettingPageNumbers(true);
    }
  }, [setFinishedSettingPageNumbers, is8Data]);

  useEffect(() => {
    setOnboardingPageNumbers();
  }, [setOnboardingPageNumbers]);

  return (
    <>
      {onboardingPages.map((page, i) => (
        <Route key={i} exact path={page.path} component={page.component} />
      ))}
    </>
  );
}
